// 20 — מייל: חשבון Gmail של משתמש (sys.mail_account) ורישום שליחה (sys.mail_message). שני הממשקים עצמם (mail.send /
// mail.read) הם שורות sys.interface רגילות (gate.ts) — כאן רק ה-credential והרישום.
import { z } from 'zod';
import { Id, Ts, rowBase } from './common.ts';

export const MailCap = z.enum(['send', 'read']);
export type MailCap = z.infer<typeof MailCap>;

export const MailAccountStatus = z.enum(['ok', 'reauth_required', 'error']);
export type MailAccountStatus = z.infer<typeof MailAccountStatus>;

/** sys.mail_account — תיבה למשתמש (אין תיבת מופע); From תמיד address. */
export const MailAccount = z.object({
  ...rowBase,
  userId: Id,
  provider: z.enum(['gmail']),
  address: z.string().min(3).max(320),
  displayName: z.string().nullable(),
  caps: z.array(MailCap),
  /** sys.secret — refresh_token. */
  secretRef: z.string().min(1),
  status: MailAccountStatus,
  lastError: z.string().nullable(),
  lastUsedAt: Ts.nullable(),
  revokedAt: Ts.nullable(),
});
export type MailAccount = z.infer<typeof MailAccount>;

/** sys.mail_message — בלי גוף ובלי כתובות. */
export const MailMessage = z.object({
  ...rowBase,
  /** NULL = מייל מערכת מתיבת המערכת (SMTP, triggers-failure-notify-retry). */
  accountId: Id.nullable(),
  kind: z.enum(['user', 'system']),
  logId: Id.nullable(),
  runId: Id.nullable(),
  conversationId: Id.nullable(),
  consentItemId: Id.nullable(),
  providerMessageId: z.string().nullable(),
  toCount: z.number().int().nonnegative(),
  toHash: z.string(),
  subject: z.string().max(200),
  bytes: z.number().int().nonnegative(),
  status: z.enum(['sent', 'failed', 'skipped_quota']),
  sentAt: Ts,
});
export type MailMessage = z.infer<typeof MailMessage>;
